import Model, { JsonArray, JsonObject } from 'src/models/model'
import ReportTableColumn from 'src/models/report/ReportTableColumn'

export const REPORT_CHART_TYPES = {
  BUBBLE: 'bubble',
  TIME_SERIES: 'time_series',
  AGGREGATE: 'aggregate'
}

export const DEFAULT_CHART_OPTIONS = function () {
  return {
    chart: {
      type: 'line'
    },
    xAxis: {
      title: {
        text: null
      },
      labels: {
        style: {
          fontSize: '12px'
        }
      },
      categories: []
    },
    yAxis: {
      title: {
        text: null
      },
      labels: {
        style: {
          fontSize: '12px'
        }
      },
      categories: []
    },
    title: {
      text: null
    },
    credits: {
      enabled: false
    },
    legend: {
      borderWidth: 0
    },
    tooltip: {
      style: {
        fontSize: '12px'
      }
    },
    plotOptions: {
      areaspline: {},
      area: {},
      series: {
        marker: {}
      }
    },
    time: {
      useUTC: false
    }
  }
}

export default class ReportChart extends Model {
  static name = 'ReportChart'

  static employeeRequiredPermissionCategories = [Model.permissionCategories.OperationsReporting]

  static define () {
    this.fields = {
      title: {
        type: String,
        output: true
      },
      subtitle: {
        type: String,
        output: true
      },
      chartType: {
        type: String,
        output: true
      },
      columns: {
        type: [ReportTableColumn]
      },
      columnOrder: {
        type: JsonArray
      },
      chartData: {
        type: JsonObject,
        default: DEFAULT_CHART_OPTIONS,
        output: true,
        mergeDefault: true
      }
    }
  }
}
